import { render } from "./MenuNavigationMobile.vue?vue&type=template&id=08f99d95&scoped=true"
import script from "./MenuNavigationMobile.vue?vue&type=script&lang=js"
export * from "./MenuNavigationMobile.vue?vue&type=script&lang=js"

import "./MenuNavigationMobile.vue?vue&type=style&index=0&id=08f99d95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f99d95"]])

export default __exports__